import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import MaButton from "../../../../Components/UI/ma-button";

export function RequireAddressDialog({
  open,
  onClose,
  onCreateAddress,
}) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: "16px",
          maxWidth: 440,
          width: "100%",
        },
      }}
    >
      <DialogTitle className="pb-2 text-[17px] font-semibold text-[#18181B]">
        Add an address first
      </DialogTitle>
      <DialogContent className="pt-2">
        <p className="my-0 text-[14px] leading-relaxed text-[#626262]">
          You need at least one shipping address before you can create a
          product. Add an address to continue.
        </p>
      </DialogContent>
      <DialogActions className="flex-wrap gap-2 px-4 pb-4 pt-0 sm:justify-end">
        <MaButton
          title="Cancel"
          onClick={onClose}
          sx={{
            bgcolor: "#F0F0F0",
            color: "#181818",
            boxShadow: "none",
            border: "none",
            minWidth: 110,
            "&:hover": { bgcolor: "#E8E8E8", boxShadow: "none" },
          }}
        />
        <MaButton
          variant="primary"
          title="Create Address"
          onClick={onCreateAddress}
          sx={{
            bgcolor: "#2E1834",
            minWidth: 140,
            "&:hover": { bgcolor: "#3B2142" },
          }}
        />
      </DialogActions>
    </Dialog>
  );
}
